import { useState } from 'react';
import type { PlatformCompany } from '../../../../types';

interface ProductBlockProps {
  show: boolean;
  company: Pick<PlatformCompany, 'productList' | 'mainProducts'>;
}

export function ProductBlock({ show, company }: ProductBlockProps) {
  const [imgError, setImgError] = useState(false);
  const product = company.productList?.[0];
  const productImg = product?.image || null;
  const productName = company.mainProducts?.[0] ?? '—';

  if (!show) return null;

  return (
    <div className="h-[56px] mt-4 mb-5 flex flex-row items-center gap-2">
      {productImg && !imgError ? (
        <img
          src={productImg}
          alt={productName}
          className="w-14 h-14 rounded object-cover bg-[#F5F5F5] shrink-0"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="w-14 h-14 rounded bg-[#F5F5F5] shrink-0" />
      )}
      <div className="flex flex-col gap-1 min-w-0">
        <span className="text-sm font-medium text-[#262626] truncate" title={productName}>
          {productName}
        </span>
        {product?.desc && <span className="text-sm text-[#8C8C8C] truncate">{product.desc}</span>}
      </div>
    </div>
  );
}
